function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8BC0FF"
    },
    points: "0,256 0,257.113 55.652,257.113 55.652,512 189.217,512 189.217,333.913 256,333.913  278.261,166.957 256,0 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3897FF"
    },
    points: "256,0 256,333.913 322.783,333.913 322.783,512 456.348,512 456.348,257.113 512,257.113  512,256 "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.1a80115a7922dc75d935fd2776dc3eb8.svg";
export { ForwardRef as ReactComponent };